import { render, staticRenderFns } from "./Invoicing.vue?vue&type=template&id=b4c34a5a&"
import script from "./Invoicing.vue?vue&type=script&lang=js&"
export * from "./Invoicing.vue?vue&type=script&lang=js&"
import style0 from "./Invoicing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports